import LicensesPage from "license/LicensesPage";
import LicenseNotificationContainer from "license/notifications/LicenseNotificationContainer";
import TrafficGraphWithLicenseMetrics from "license/TrafficGraphWithLicenseMetrics";
import TrafficGraph from "license/TrafficGraph";
import LicenseCheckProvider from "license/LicenseCheckProvider";
import EnterpriseProductLink from "license/EnterpriseProductLink";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
import LicensesRoutes from "license/Routes";
const licenseBindings = {
  license: [
    {
      TrafficGraph,
      // @ts-expect-error Should be fixed later
      EnterpriseProductLink,
      TrafficGraphWithLicenseMetrics
    }
  ],
  routes: [{ path: LicensesRoutes.unqualified.LIST, component: LicensesPage }],
  globalNotifications: [
    {
      key: "org.graylog.plugins.license.LicenseNotificationContainer",
      component: LicenseNotificationContainer
    }
  ],
  globalContextProviders: [LicenseCheckProvider],
  "licenseCheck": [useLicenseValidityForSubject]
};
export default licenseBindings;
